<template>
    <div class="row">
        <div class="col-12">
            <div class="panel-sub-heading headingLarge" v-if="!is_reviewing">
                <span class="h5 display-6 markedBottom bold">{{ lang('uploaded_documents') }}</span>
                <span v-if="isPiiDataMaskedDocument" class="float-right float-end">
                    <a class="btn btn-sm btn-default btn-with-label" @click="unmaskHandler">
                        <span class="btn-label"><i class="fas fa-pencil-alt"></i></span>
                        {{lang('unmask')}}
                    </a>
                </span>
            </div>
        </div>
        <template v-if="ekycAllowedByWorkflow && signerOwner.ekyc_verification == '1'">
            <div class="col-12">
                <np-notice :notice="this.lang('notice_ekyc_verification_yes')"></np-notice>
            </div>
        </template>
        <template v-if="signerOwner.idpal_verification == '1' && !!signerOwner.idpal_uuid">
            <div class="col-12">
                <np-notice :notice="lang('documents_to_be_verified_by_idpal')"></np-notice>
            </div>
        </template>
        <div class="col-12" v-else-if="isSignerUser && !noDocumentSelected && getDocuments(true).length <= 0">
            <np-notice :notice="lang('no_supporting_documents_uploaded')"></np-notice>
        </div>
        <div v-else>

<template v-for="(category) in getDocumentCategories()"
          :key="category.id">
        <div class="col-12"  v-if="category.selected">
            <div class="panel-sub-heading">
                <span class="h5 display-6 markedBottom bold">{{ formatUploadDocumentCategory(category.id) }}</span>
            </div>
            <div class="panel-body">
                <div class="row m-2">
                    <div class="col-12">
                        <div class="row">
<template v-for="(document, doc_index) in getDocuments(true)">
                            <div class="col-lg-4 col-md-6 col-12"
                                 v-if="category.id == document.document_category_external_id && document.selected === '1'">
                                <div class="card paddingBottom20">
                                    <div class="card-header">
                                        <div class="row">
                                            <div class="col-12">
                                                <span>{{formatUploadDocumentType(document)}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card-body">
                                            <np-entry
                                                    v-if="document.document_entity_id"
                                                    :id="`document_for_${doc_index}_${category.id}`"
                                                    :name="`document_for_${doc_index}_${category.id}`"
                                                    :label="lang('document_for')"
                                                    mode="inline"
                                                    :no-wrapper="false"
                                                    :model-value="formatEntityName(document.document_entity_id, document.selected_entity_id)">
                                            </np-entry>
                                        <div class="col-12 p-0">
                                            <div v-if="isUploading" style="text-align: center">
                                                            <span style="display: inline-block" class="btn btn-default"
                                                            ><i class="fa fa-spinner fa-spin"></i></span>
                                            </div>
                                            <ul class="list-group mb-2"
                                                v-if="document.uploaded_files.length > 0">
                                                <template v-for="(file) in document.uploaded_files" :key="file.id">
                                                <li class="mb-1 list-group-item "
                                                    v-if="file.success === true"
                                                    >
                                                  <div class="d-flex justify-content-between align-items-center">
                                                    <i v-if="isPdfFile(file.file_name)" class="fa fa-file-pdf fa-2x me-1"></i>
                                                    <i v-else class="fa fa-file-image fa-2x me-2"></i>
                                                    <div style="display: block">
                                                    <span class=""
                                                          style="text-transform: capitalize; font-size: 12px; word-break: normal; overflow-wrap: anywhere">
                                                      {{ file.name }}
                                                    </span>
                                                      <span> {{ formatSize(file.size) }} </span>
                                                    </div>
                                                  </div>

                                                </li>
                                                </template>
                                            </ul>
                                        </div>
                                        <div class="row mt-3" v-if="document.document_entity_id">
                                            <div class="col-12 mb-1">
                                                <span class="markedBottom" style="font-size: 13px; font-weight: bold">{{ lang('document_values') }}</span>
                                            </div>
                                            <template v-for="(value) in document.values">
                                            <div class="col-lg-6 col-md-6 col-sm-12 col-12"
                                                 v-if="value.attribute.selected == '1'">
                                                <np-entry
                                                        :ref="`${document.id}_${value.field_name}`"
                                                        mode="inline"
                                                        :id="`${document.id}_${value.field_name}`"
                                                        :name="`${document.id}_${value.field_name}`"
                                                        :label="lang(`${value.field_name}`)"
                                                        :required="value.attribute.is_required == '1'"
                                                        v-show="value.attribute.dependent != 'Y'"
                                                        :no-wrapper="false"
                                                        :model-value="formatValue(value, !isSignerOwnerDocument(document))">
                                                </np-entry>
                                            </div>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
</template>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>
        <div class="col-12" v-if="noDocumentSelected">
            <np-skeleton v-if="is_loading" class="col-12" :type="'pricing'"></np-skeleton>
            <np-notice v-else :notice="lang('no_supporting_documents_uploaded')"></np-notice>
        </div>
        <div class="col-12" v-else-if="isSignerUser && (getSignerDocumentCategories().length <= 0 || getDocumentCategories().length <=0)">
            <np-notice :notice="lang('no_supporting_documents_uploaded')"></np-notice>
        </div>
        </div>
        <div class="col-12">
            <div class="row mt-4" style="border-top: 1px solid #b2c6d0">
                <div class="col-12">
                    <div class="my-3" v-if="loading_document_upload">
                        <button v-if="!is_reviewing" :disabled="true" class="btn btn-danger me-1"> {{lang('go_back')}}
                        </button>
                        <button v-if="!is_reviewing" :disabled="true" type="button" class="btn btn-default me-1">
                            {{lang('continue')}}
                        </button>
                    </div>
                    <div class="my-3" v-else>
                        <button v-if="!is_reviewing" class="btn btn-danger me-1" @click="goBack"> {{lang('go_back')}}
                        </button>
                        <button v-if="!is_reviewing" type="button" class="btn btn-default me-1" @click="doContinue">
                            {{lang('continue')}}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <div class="exactCenter" v-if="loading_document_upload">
            <div class="card">
                <div class="card-header">
                    <span class="h5 display-6 bold">{{lang('please_wait')}}</span>
                </div>
                <div class="card-body text-center">
<!--                    <vue-spinner :font-size="15" :message="lang('loading')"></vue-spinner>-->
                    <div class="d-flex justify-content-center">
                        <div  class="spinner-border" role="status" aria-hidden="true"></div>
                    </div>
                    <span style="font-size: 15px;">{{lang('please_wait')}}</span>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import documentMixin from "../../../utils/document-mixin";
    import applicationMixin from "../../../utils/application-mixin";
    import {
        NPCheckBox,
        NPCompanySearch,
        NPDatePicker, NPEntry,
        NPInput, NPNotice,
        NPModal, NPPhone, NPPostcodeSearch,
        NPRadios, NPResponsive,
        NPSelect2, NPSkeleton,
        NPTextArea, NPVat, NPDocumentUploadWidget, NPUpload
    } from "netpify/components";
    import VueUploadComponent from 'vue-upload-component';
    import {mapState} from "pinia";
    import useApplicationStore from "../../../stores/application_module";

    export default {
        name: "viewDocumentUpload",
        mixins: [documentMixin],
        components: {
            'file-upload': VueUploadComponent,
            'np-upload-widget': NPDocumentUploadWidget,
            'np-modal': NPModal,
            'np-textarea': NPTextArea,
            'np-radios': NPRadios,
            'np-input': NPInput,
            'np-checkbox': NPCheckBox,
            'np-date-picker': NPDatePicker,
            'np-select2': NPSelect2,
            'np-company-search': NPCompanySearch,
            'np-postcode-search': NPPostcodeSearch,
            'np-responsive': NPResponsive,
            'np-vat': NPVat,
            'np-phone': NPPhone,
            'np-skeleton': NPSkeleton,
            'np-upload': NPUpload,
            'np-notice': NPNotice,
            'np-entry': NPEntry,
        },
        metaInfo() {
            return {
                title: this.lang('documents_upload')
            }
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.setAppPageTitle(vm.page_label)
                if ( vm.isOpenApplication && ( !vm.hasMerchantControl && vm.merchantToUpload ) ) {
                    //vm.$router.push({path: `/application/edit/${vm.$route.params.application_reference}/documents/`})
                }
            })
        },
        data (){
            return {
                is_loading: true
            }
        },
        mounted: function() {
            let vm = this;
            vm.is_loading = true;
            setTimeout(function () {
                vm.is_loading = false;
            }, 3000);
        },
        props: {
            is_reviewing: {
                default: false,
                type: Boolean,
            }
        },
        computed: {
            ...mapState(useApplicationStore, {loading_document_upload:'loading_document_upload'}),
        },
        methods: {
            isPdfFile: function(file_name) {
                var ext = file_name.split('.').reverse()[0];
                return  ( ext === 'pdf' );
            },
            formatValue: function (value, mask = false) {
                if(value.attribute.type == 'country_param') {
                    return this.formatSelectType(this.parameters, value.field_value, 'COUNTRIES_PARAM');
                }
                if(value.attribute.type == 'state_param') {
                    return this.formatSelectType(this.parameters, value.field_value, 'STATES_PARAM');
                }
                if(value.field_name == 'date_of_birth') {
                     return this.formatDate(value.field_value);
                }
                if(value.field_name == 'issued_date') {
                    return this.formatDate(value.field_value);
                }
                if(value.field_name == 'expiry_date') {
                    return this.formatDate(value.field_value);
                }
                if (value.field_name == 'document_id') {
                    if (mask) {
                        return this.maskingString(value.field_value, '*');
                    }
                    return !!value.field_value ? value.field_value : '-';
                }
                return value.field_value;
            },
            doContinue: function () {
                if (this.isSignerUser && (this.application_root_path.includes('/application/add') || this.application_root_path.includes('/application/edit'))) {
                    location.href = '/';
                }
                this.$router.push({path: this.application_root_path + 'review/'});
            },
            goBack: function () {
                this.abortRouteLeave = true;
                this.$router.push({path: `${this.application_root_path}business_details/principals/`});
            },
            maskingString: function (str, mask = '*') {
                if (str.length <= 1 || str.includes(mask)) {
                    return str;
                }
                let start = 0;
                let end = 0;

                // from 2 chars
                if (str.length === 2) {
                    start = 1;
                    end = 2;
                } else if (str.length >= 3 && str.length <= 4) {
                    start = 1;
                    end = str.length - 1;
                } else if (str.length === 5) {
                    start = 2;
                    end = str.length - 1;
                } else if (str.length >= 6) {
                    start = 2;
                    end = str.length - 2;
                }
                if (!str || start < 0 || start >= str.length || end < 0 || end > str.length || start >= end) {
                    return str;
                }
                const maskLength = end - start;
                return str.substring(0, start) + mask.repeat(maskLength) + str.substring(end);
            },
            maskCharacter: function (str, mask, n = 1) { // Function for masking the character
                // Slice the string and replace with
                // mask then add remaining string
                return ('' + str).slice(0, -n).replace(/./g, mask) + ('' + str).slice(-n);
            },
        }
    }
</script>

<style scoped>
    .exactCenter {
        width:250px;
        height:200px;
        position: fixed;
        top: 50%;
        left: 50%;
        margin-top: -100px;
        margin-left: -100px;
        z-index: 50000;
    }
</style>
